import * as React from 'react';
import {
    List,
    Datagrid,
    DateField,
    TextField,
    SearchInput,
    TextInput,
    SelectInput,
    SelectField,
} from 'react-admin';
import { useMediaQuery, Theme } from '@mui/material';

import MobileGrid from './MobileGrid';

const order_document_categories_override_choices = [
    {
        id: 'general',
        name:
            'resources.logix_users.fields.order_document_categories_override__general',
    },
    {
        id: 'personal',
        name:
            'resources.logix_users.fields.order_document_categories_override__personal',
    },
];

const entityFilters = [
    <SearchInput source="q" alwaysOn />,
    <TextInput source="id" />,
    <TextInput source="user_id" />,
    <TextInput source="access_client_id" />,
    <TextInput source="email" />,
    <TextInput source="phone" />,
    <SelectInput
        source="order_document_categories_override"
        fullWidth
        helperText="resources.logix_users.fields.order_document_categories_override__helperText"
        choices={order_document_categories_override_choices}
    />,
];

const EntityList = () => {
    const isXsmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
    );
    // const isSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('md'));
    return (
        // @ts-ignore
        <List
            filters={entityFilters}
            resource="logix_users"
            sort={{ field: 'created', order: 'DESC' }}
            perPage={25}
        >
            {isXsmall ? (
                <MobileGrid />
            ) : (
                <Datagrid
                    optimized
                    rowClick="edit"
                    sx={{
                        '& .column-groups': {
                            md: { display: 'none' },
                            lg: { display: 'table-cell' },
                        },
                    }}
                >
                    <TextField source="id" />
                    <TextField source="user_id" />
                    <TextField source="access_client_id" />
                    <TextField source="email" />
                    <TextField source="phone" />
                    <SelectField
                        source="order_document_categories_override"
                        fullWidth
                        helperText="resources.logix_users.fields.order_document_categories_override__helperText"
                        choices={order_document_categories_override_choices}
                    />
                    <DateField source="created" showTime={true} />
                    <DateField source="modified" showTime={true} />
                </Datagrid>
            )}
        </List>
    );
};

export default EntityList;
